import type { Toast as ToastState } from '../lib/useToast.ts';
import { X } from '../lib/icons.tsx';

type ToastProps = {
  toast: ToastState | null;
  onUndo: () => void;
  onDismiss: () => void;
};

/**
 * The single transient toast (see lib/useToast.ts). Rendered bottom-centre
 * over the stage; `role="alert"` so screen readers announce mutations.
 */
export default function Toast({ toast, onUndo, onDismiss }: ToastProps) {
  if (!toast) return null;
  return (
    <div className={'toast toast--' + toast.tone} role="alert">
      <span className="toast__message">{toast.message}</span>
      {toast.undo && (
        <button type="button" className="toast__undo link" onClick={onUndo} disabled={toast.undoing}>
          {toast.undoing ? '…' : toast.actionLabel || 'Undo'}
        </button>
      )}
      <button type="button" className="toast__close iconbtn" onClick={onDismiss} aria-label="Dismiss">
        <X />
      </button>
    </div>
  );
}
